import React, {Component} from 'react';

class IconLamp extends Component {
  render() {
    const {color, size} = this.props;
    const h = size === "lg"
      ? 128
      : 48;
    const w = size === "lg"
      ? 128
      : 48;
    return (<i className="emoji">
      <svg style={{
          fill: color
        }} className="emoji" viewBox="2 0 76 76" height={h} width={w} xmlns="http://www.w3.org/2000/svg">
        <path d="M40,7C27.3,7,17,17.3,17,30c0,7.3,3.2,11.9,6.3,15.3c1.5,1.7,3,3.2,4.1,4.6c1.1,1.4,1.7,2.7,1.7,4.1v10c0,2.8,2.3,5,5,5
        		h1.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4H46c2.8,0,5-2.3,5-5V54c0-1.5,0.6-2.7,1.7-4.1c1.1-1.4,2.5-2.9,4.1-4.6
        		c3.1-3.4,6.3-8,6.3-15.3C63,17.3,52.7,7,40,7z M40,9c11.6,0,21,9.4,21,21c0,6.7-2.8,10.6-5.8,14c-1.5,1.7-3,3.1-4.2,4.7
        		C49.9,50.2,49,52,49,54v1h-5V34.8c1.7-0.5,3-2,3-3.8c0-2.2-1.8-4-4-4c-1.2,0-2.3,0.6-3,1.4c-0.7-0.9-1.8-1.4-3-1.4
        		c-2.2,0-4,1.8-4,4c0,1.8,1.3,3.3,3,3.8V55h-5v-1c0-2-0.9-3.8-2.1-5.3c-1.2-1.6-2.7-3-4.2-4.7c-2.9-3.3-5.8-7.2-5.8-14
        		C19,18.4,28.4,9,40,9z M37,29c1.1,0,2,0.9,2,2h2c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2h-1v22h-4V33h-1c-1.1,0-2-0.9-2-2
        		S35.9,29,37,29z M31,57h18v2H37v2h12v2H37v2h11.8c-0.4,1.2-1.5,2-2.8,2H34c-1.3,0-2.4-0.8-2.8-2H35v-2h-4v-2h4v-2h-4V57z M37.2,69
        		h5.6c-0.4,1.2-1.5,2-2.8,2S37.6,70.2,37.2,69z"/>
      </svg>
    </i>)
  }
};

export default IconLamp;



// WEBPACK FOOTER //
// ./src/style/icon/IconLamp.js